import React, { Fragment } from 'react';
import { Container, Row, Col } from 'reactstrap';
import HeaderLogo from '../../sharedComponents/Header/HeaderLogo';
import useActivate from './useActivate';
import { useParams } from 'react-router-dom';

const Activate = () => {
  const logo = localStorage.getItem('branding') === "ARROWSTREAM" ? './arrowstreamLogoWhite.png' : process.env.REACT_APP_COMPANY_LOGO;
  const token = useParams()['*'];
  useActivate(token);

  return (
    <Fragment>
      <HeaderLogo logo={logo} />
      <Container fluid className='flex-grow-1'>
        <Row className='justify-content-center'>
          <Col style={{maxWidth: '400px'}}>
            <Row className='py-5'>
              <Col className='text-center text-size-20 font-weight-bold'>Loading...</Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default Activate;